import { useQuery } from '@tanstack/react-query'
import { getOrganizationContact } from '@/api/services/organization.service'

/** Who to ask for access; readable by every signed-in member. */
export function useOrganizationContact() {
  return useQuery({
    queryKey: ['organization', 'contact'] as const,
    queryFn: getOrganizationContact,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}
